export enum PaymentMethod {
    cheque = 'cheque',
    money = 'espece',
}
